import { Smile, Bold, PenTool, Paperclip, Send, Monitor, Mic } from 'lucide-react';

// 02.9-shared-widgets.md paso b (§5) -- extraido de CommentArea.jsx, sin cambios de
// comportamiento. `isRecording`/`onToggleRecording` reemplazan la lectura/escritura directa de
// useScreenRecordStore + el ref `recStartTickRef`, que se quedan en el padre (dueño del efecto
// que escucha `finishedTick`).
const CommentToolbar = ({ isRecording, onToggleRecording, onFilesSelected, onSend }) => {
    return (
        <div className="editor-toolbar">
            <button className="toolbar-btn" title="Stickers">
                <Smile size={16} />
            </button>
            <button className="toolbar-btn" title="Adjuntar archivo" onClick={() => document.getElementById('comment-file-upload').click()}>
                <Paperclip size={16} />
            </button>
            <button
                className={`toolbar-btn ${isRecording ? 'active-rec-comment' : ''}`}
                title={isRecording ? "Detener Grabación" : "Grabar Pantalla"}
                onClick={onToggleRecording}
            >
                <Monitor size={16} />
            </button>
            <button className="toolbar-btn" title="Grabar Audio" disabled style={{ opacity: 0.3, cursor: 'not-allowed' }}>
                <Mic size={16} />
            </button>

            <div style={{ width: '1px', height: '16px', background: '#444', margin: '0 4px' }} />

            <button
                className="toolbar-btn"
                disabled
                style={{ opacity: 0.3, cursor: 'not-allowed' }}
                title="Dibujar (Próximamente)"
            >
                <PenTool size={16} />
            </button>

            <input
                type="file"
                id="comment-file-upload"
                multiple
                style={{ display: 'none' }}
                onChange={async (e) => {
                    if (e.target.files.length > 0) {
                        for (let i = 0; i < e.target.files.length; i++) {
                            await onFilesSelected(e.target.files[i]);
                        }
                    }
                }}
            />

            <div style={{ flex: 1 }} />

            <button className="toolbar-btn" title="Enviar" onClick={onSend} style={{ color: '#60a5fa' }}>
                <Send size={16} />
            </button>
        </div>
    );
};

export default CommentToolbar;
